export default __webpack_public_path__ + "static/media/comments.fa342753.svg";